<template lang="pug">
  .review-carousel.container
    .row
      .xs-12
        .carousel-wrap.xs-f-small.md-f-medium.lg-f-large.max-at-tweak.text-center
          .the-carousel
            slick(ref="slick" v-bind:options="{ autoplay: true, autoplaySpeed: 4000, speed: 1000, slidesToShow: 1, dots: true, arrows: false }")
              .simple-review-vue(v-for="(review, index) in reviews" :key="index")
                stars.review-text.xs-f-xlarge.sm-f-xlarge.md-f-large.lg-f-xlarge.max-at-tweak(:rating="review.rating")
                p.review-text.xs-f-large.sm-f-large.md-f-xmedium.lg-f-large.max-at-tweak {{review.text}}
                p.review-customer-product.color-slate.upper.xs-f-medium.sm-f-medium.md-f-small.lg-f-medium.max-at-tweak {{review.product}}
                p.review-customer-name.color-slate.xs-f-xmedium.sm-f-xmedium.md-f-medium.lg-f-xmedium.max-at-tweak {{review.name}}

</template>

<script>
  export default {
    name: "ReviewCarousel",

    data() {
      return {
        reviews: [
          {
            rating: 5,
            text: '“People have complimented the shade of my hair...I am so happy I just saved 3 hours of my life and over $100!”-Karen',
            product: 'milano brown',
            name: '- Karen'
          },
          {
            rating: 5,
            text: '“My hair is soft, shiny and I actually love my hair for the first time. Love This!!!!!!”',
            product: 'bologna blonde',
            name: '- Lisa'
          },
          {
            rating: 5,
            text: '“Love the rich color. Easy to color myself. Saves time and money!”',
            product: 'tuscany brown',
            name: '- Laura'
          },
          {
            rating: 5,
            text: '“The color is amazing....I can not say enough great things. I receive compliments daily!”',
            product: 'rimini garnet',
            name: '- Cindy'
          }
        ]
      }
    }
  }
</script>

<style scoped lang="stylus">
  .review-carousel
    background-color color-white
    padding-bottom 4em
    
    .simple-review-vue
      .mr-stars
        margin-bottom 1.5em
    
      .review-text
        margin-bottom 1em
        padding 0 1em

      .review-customer-name
        margin-bottom 0.5em

    .carousel-wrap
      margin 2em auto
      max-width 450px

      .the-carousel
        padding 0

    .slick-dots
      bottom -2em
      
      li
        margin 0 1px
        
        button
          &:before
            font-size 44px
            
      li.slick-active
        button
          &:before
            color #600057
    
</style>
